module.exports = __webpack_public_path__ + "img/kemendikbud.56e2d556.webp";